import { render, staticRenderFns } from "./ipt-multiple.vue?vue&type=template&id=2b61120b&scoped=true&"
import script from "./ipt-multiple.vue?vue&type=script&lang=ts&"
export * from "./ipt-multiple.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-multiple.vue?vue&type=style&index=0&id=2b61120b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61120b",
  null
  
)

export default component.exports